import React from 'react';
import gql from 'graphql-tag';
import { useDispatch } from 'react-redux';
import { hooks } from 'lib.front';
import { clientLog } from 'common/gqlClientes';
import { loadingModal, openMsg, logOut } from 'redux-app';

const logOutQ = gql`
   {
      logOutIntra {
         msg
      }
   }
`;

export default function useLogOut() {
   // REDUX
   const dispatch = useDispatch();
   //CALLBACKS LOGIN
   function callbackProcesarData(data) {
      dispatch(logOut());
   }

   function callbackLoading(loading) {
      dispatch(loadingModal(loading));
   }

   function callbackError(error) {
      dispatch(openMsg(JSON.stringify(error)));
      dispatch(logOut());
   }

   const [logOutCall] = hooks.useApolloLazyQ(
      logOutQ,
      {
         callbackProcesarData,
         callbackLoading,
         callbackError
      },
      {
         client: clientLog
      }
   );
   return logOutCall;
}
